function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.889 6.104v9.623a.9.9 0 01-.889.91.9.9 0 01-.889-.91V6.104L8.073 8.188a.875.875 0 01-1.257 0 .924.924 0 010-1.285l3.554-3.637a.875.875 0 011.258 0l3.555 3.637a.924.924 0 010 1.285.875.875 0 01-1.257 0l-2.037-2.084zM3 13a.9.9 0 01.889-.91.9.9 0 01.889.91v7.273a.9.9 0 00.889.909h10.666a.9.9 0 00.89-.91V13a.9.9 0 01.888-.91A.9.9 0 0119 13v7.273C19 21.779 17.806 23 16.333 23H5.667C4.194 23 3 21.779 3 20.273V13z"
});

var SvgShare = function SvgShare(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/share.6e7ad765.svg";
export { SvgShare as ReactComponent };